// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2flLJ","errorLogs":"styles_errorLogs__1kV5A"};